import React from "react";
import { Link } from "react-router-dom";
import Layout from "../components/Layout";
import SEO from "../components/SEO";
import { INSIGHTS } from "./insights_data";

/**
 * /insights — editorial index. Deliberately typography-first (no imagery),
 * cream/ink palette, left-aligned reading flow. Content is stored in
 * insights_data.jsx as plain JSX so new posts require zero build tooling.
 */
export default function Insights() {
  return (
    <Layout>
      <SEO
        title="Insights — Regulated Carbon Markets"
        description="Deep-dives on the regulated carbon market: UCS vs Verra REDD+, Article 6.4 of the Paris Agreement, SBTi 2030 disclosure, and how corporate ESG teams should structure their offset portfolios."
        path="/insights"
      />

      <section className="max-w-4xl mx-auto px-6 lg:px-10 pt-20 pb-8">
        <div className="label-tag">Insights</div>
        <h1 className="font-serif text-5xl lg:text-6xl mt-3 tracking-tight" data-testid="insights-title">
          Regulated markets, honestly explained.
        </h1>
        <p className="text-ink2 mt-6 max-w-2xl leading-relaxed text-lg">
          Field notes for sustainability officers, treasurers, and ESG teams navigating the shift from
          unregulated voluntary carbon credits to publicly-registered, tier-1-audited instruments.
        </p>
      </section>

      <section className="max-w-4xl mx-auto px-6 lg:px-10 pb-24">
        <div className="border-t border-line pt-4">
          {INSIGHTS.map((post) => (
            <Link
              key={post.slug}
              to={`/insights/${post.slug}`}
              className="block border-b border-line py-8 group"
              data-testid={`insight-card-${post.slug}`}
            >
              <div className="flex items-center gap-3 text-xs font-mono uppercase tracking-[0.22em] text-ink2">
                <span>{post.date}</span>
                <span>·</span>
                <span>{post.read}</span>
                {post.tags?.slice(0, 2).map((tag) => (
                  <span key={tag} className="border border-line px-2 py-0.5 text-[10px]">{tag}</span>
                ))}
              </div>
              <h2 className="font-serif text-3xl lg:text-4xl mt-4 tracking-tight text-ink group-hover:text-leaf transition-colors leading-tight">
                {post.title}
              </h2>
              <p className="text-ink2 mt-4 leading-relaxed max-w-2xl">{post.excerpt}</p>
              <div className="mt-5 text-xs font-mono uppercase tracking-[0.22em] text-ink2 group-hover:text-ink">
                Read →
              </div>
            </Link>
          ))}
        </div>
      </section>
    </Layout>
  );
}
